export const BirdviewDwellerWidget = {
  Announcements: 'announcements',
  Documents: 'documents',
  Home: 'home',
  Messages: 'messages',
  Objects: 'objects',
  Requests: 'requests',
}

export const BIRDVIEW_DWELLER_WIDGET_TITLE_KEY = {
  [BirdviewDwellerWidget.Announcements]:
    'DashboardBirdview.AnnouncementsTitleKey',
  [BirdviewDwellerWidget.Documents]: 'DashboardBirdview.DocumentsTitleKey',
  [BirdviewDwellerWidget.Home]: 'DashboardBirdview.HomeTitleKey',
  [BirdviewDwellerWidget.Messages]: 'DashboardBirdview.MessagesTitleKey',
  [BirdviewDwellerWidget.Objects]: 'DashboardBirdview.ObjectsTitleKey',
  [BirdviewDwellerWidget.Requests]: 'DashboardBirdview.RequestsTitleKey',
}

// A tenant keeps their home at hand; a landlord leads with the objects they
// own and has no home card.
export const BIRDVIEW_DWELLER_LAYOUT = {
  left: [
    BirdviewDwellerWidget.Requests,
    BirdviewDwellerWidget.Messages,
    BirdviewDwellerWidget.Documents,
  ],
  right: [BirdviewDwellerWidget.Home, BirdviewDwellerWidget.Announcements],
}

export const BIRDVIEW_LANDLORD_LAYOUT = {
  left: [
    BirdviewDwellerWidget.Objects,
    BirdviewDwellerWidget.Requests,
    BirdviewDwellerWidget.Documents,
  ],
  right: [BirdviewDwellerWidget.Announcements, BirdviewDwellerWidget.Messages],
}
